const popContext = {
  pop_download: {
    header: 'Download Truckloads App to enjoy more access',
    body: [
      'Enjoy the many unipe features of the Truckloads app including:',
      [
        'Search 150,000 available loads daily',
        'Check a broker\'s credit score',
        'Redo your previous searched',
        'Stay tuned with push noticefications',
      ],
      'Watch the demo or visit an app store to learn more about the great features pf Truckloads.',
    ],
    btnTXT: 'WATCH DEMO',
  },
  pop_upgrade_to_standard: {
    header: 'Upgrade or download App to contact the Brokers',
    body: [
      'Upgrade your account to contact your partners for more'
      + ' information by call or download Truckloads APP for more free views.',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_upgrade_to_standard_brokers: {
    header: 'Want to access Broker info?',
    body: [
      'Upgrade for more information or download the Truckloads APP for more details.',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_upgrade_to_save_brokers: {
    header: 'Upgrade or download App to Save the Brokers',
    body: [
      'Upgrade your account to save your favorite brokers/shippers'
      + ' by call or download Truckloads App for more free views.',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_upgrade_to_hide_brokers: {
    header: 'Upgrade or download App to Block the Brokers',
    body: [
      'Upgrade your account to block the Brokers/Shippers you prefer'
      + ' not to work with by call or download Truckloads App for more free views.',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_upgrade_to_premium: {
    header: 'Upgrade Your Account',
    body: [
      'This is a Preferred membership feature. Upgrade your account to use this feature or download the Truckloads app for more details.',
    ],
    btnTXT: 'Upgrade My Account',
  },
  pop_upgrade_to_essential_standard: {
    header: 'Upgrade Your Account',
    body: [
      'This is a Essential membership feature. Upgrade your account to use this feature or download the Truckloads app for more details.',
    ],
    btnTXT: 'Upgrade My Account',
  },
  pop_upgrade_to_premium_est : {
    header: 'The price for this load is not offered',
    body: [
      'The estimated price is calculated based on the offer of'
      + ' similar loads posted in the past 30 days',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_upgrade_to_save: {
    header: 'Upgrade Your Account!',
    body: [
      'Daily complimentary usage reached! For unlimited access, upgrade via our website or call today!',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_upgrade_to_loads_above_limits: {
    header: 'Daily Free Details Completed!',
    body: [
      'Come back tomorrow for additional free usage. For unlimited access, upgrade via our website or call today!',
    ],
    btnTXT: 'Upgrade My account',
  },
  pop_download_and_send_verify_email: {
    header: 'Please validate your account',
    body: [
      `To provide a better service, we need to validate all carriers’ accounts.
      Please go to My Account to confirm your email and fill out your profile.`,
    ],
    btnTXT: 'Resend Confirmation Email',
  },
  pop_upgrade_to_new_standard: {
    header: 'Daily Limit Reached',
    body: [
      'Since 2015, Truckloads has made finding nearby loads free and efforts.',
      'Help Truckloads find you more loads by upgrading to our preferred service',
      'Upgrade to Preferred for',
      'unlimited loads + no ads',
    ],
    btnTXT: ['Wait Instead', 'Upgrade'],
  },
  pop_upgrade_to_new_professional: {
    header: 'Upgrade Your Account!',
    body: [
      'This is a Ultimate feature,upgrade your account for more userful features or download Truckloads APP for more details.'
    ],
    btnTXT: 'Upgrade My account',
  }
};
export default popContext;



// WEBPACK FOOTER //
// ./src/components/Popup/config.js